import React, { Component } from 'react';
import Button from '@dbk/ui-buttons';
import { createContainer } from '@dbk-legacy/muster/react';
import Text from '@dbk/ui-text';
import config from '../../data/settings.json';  
import { REMOTE_URL } from '../../../../../src/constants';
import {isAndroid , isIos } from 'react-device-detect';
import DBLogo from '../../../../../src/common/components/icons/db-logo-text';
import MobileBrowserIcon from '../../../../../src/components/common/icons/mobile-browser-icon';

class MobileWebLanding extends Component {
    constructor(props){
      super(props);
    }

  render() {
     const { i18n: { messages }} = this.props;
     let androidUrl =  REMOTE_URL.ANDROID + config.store.playstoreId;
     let iosUrl = REMOTE_URL.IOS + config.store.appstoreId;
     
      return (
        <div className ="mobileWebContainer">
          <DBLogo className="name_logo"/>
       
         <div className="mobile_browser_div"> 
           <MobileBrowserIcon  className="mobile_browser_icon"/>
        </div>
              <div className="text-content">
                <Text className="text-message">
                 {messages[ ( isAndroid ) ? 'app.mobileWeb.textmessageAndoroid':'app.mobileWeb.textmessageIos']}
                </Text>
              </div>
             <div className="Button-content"> 
               <a className="buttonAnchor" href={( isAndroid ) ? androidUrl: iosUrl} >
                    <Button fullWidth large className="ButtonText">
                    {messages['app.mobileWeb.buttonText']}
                    </Button>
              </a>
             </div> 
        </div>
      );
  }
}
export default
 createContainer({
  $queries: {
    i18n: {
      messages: true,
    }   
  }
})
(MobileWebLanding);
